import styled from 'styled-components/macro';

export const StyledMidHistory = styled.div`
  margin-bottom: 20px;

  h3 {
    margin-bottom: 15px;
    color: var(--primary-color);
  }

  h4 {
    margin: 15px 0 10px 0;
    font-size: 14px;
    font-weight: 600;
    color: var(--text-color-primary);
  }
`;

export const StyledCurrentMid = styled.div`
  background: var(--success-color-light);
  border: 2px solid var(--success-color);
  border-radius: 8px;
  padding: 12px 16px;
  font-weight: 600;
  color: var(--success-color-dark);
  margin-bottom: 10px;
  position: relative;

  &:before {
    content: 'CURRENT';
    position: absolute;
    top: -8px;
    right: 10px;
    background: var(--success-color);
    color: white;
    font-size: 10px;
    padding: 2px 6px;
    border-radius: 3px;
    font-weight: 700;
  }
`;

export const StyledPreviousMid = styled.div`
  background: var(--light-color);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 10px 14px;
  margin-bottom: 8px;
  color: var(--text-color-secondary);
  font-weight: 500;

  &:last-child {
    margin-bottom: 0;
  }
`;
